import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { app } from '@microsoft/teams-js';
import Loader from './components/loader/Loader';
import appInsightsService from './services/applicationInsights';

const ProtectedRoute = ({ element }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isInTeams, setIsInTeams] = useState(false);

  useEffect(() => {
    // Track ProtectedRoute check
    appInsightsService.trackEvent('ProtectedRouteCheck', {
      path: window.location.href,
      userAgent: navigator.userAgent,
      timestamp: new Date().toISOString()
    });
    
    // CRITICAL FIX: Check user agent first - if we're clearly in Teams, don't rely on SDK
    const isMobileTeams = /TeamsMobile|Android.*Teams|iPhone.*Teams|iPad.*Teams/i.test(navigator.userAgent);
    const isAnyTeams = /Teams|TeamsMobile/i.test(navigator.userAgent);
    
    if (isAnyTeams) {
      // We're definitely in Teams based on user agent - trust this over SDK
      console.log('🛡️ ProtectedRoute: Teams detected via user agent, allowing access');
      appInsightsService.trackEvent('ProtectedRouteUserAgentSuccess', {
        path: window.location.href,
        userAgent: navigator.userAgent,
        isMobile: isMobileTeams,
        method: 'user_agent_detection'
      });
      setIsInTeams(true);
      setIsLoading(false);
      return;
    }
    
    // Not in Teams based on user agent, try SDK (but with shorter timeout for mobile)
    const timeoutMs = isMobileTeams ? 3000 : 5000;
    
    Promise.race([
      Promise.resolve()
        .then(() => {
          appInsightsService.trackEvent('ProtectedRouteInitializing', {
            path: window.location.href,
            timeoutMs
          });
          return app.initialize();
        })
        .then(() => {
          appInsightsService.trackEvent('ProtectedRouteInitialized', {
            path: window.location.href
          });
          return app.getContext();
        })
        .then((context) => {
          appInsightsService.trackEvent('ProtectedRouteContextSuccess', {
            path: window.location.href,
            context: JSON.stringify(context)
          });
          return true;
        }),
      // Timeout promise
      new Promise((_, reject) => 
        setTimeout(() => reject(new Error('SDK timeout after ' + timeoutMs + 'ms')), timeoutMs)
      )
    ])
    .then(() => {
      setIsInTeams(true);
    })
    .catch((err) => {
      appInsightsService.trackEvent('ProtectedRouteError', {
        path: window.location.href,
        error: err.message || 'Unknown error',
        errorType: err.name || 'UnknownError',
        errorStack: err.stack || 'No stack',
        fullError: JSON.stringify(err, Object.getOwnPropertyNames(err)),
        isTimeout: err.message?.includes('timeout') || false
      });
      
      // Final fallback: If we got here and user agent shows Teams, trust it
      if (isAnyTeams) {
        console.log('🛡️ ProtectedRoute: SDK failed but user agent shows Teams - allowing access');
        appInsightsService.trackEvent('ProtectedRouteFallbackSuccess', {
          sdkError: err.message,
          userAgent: navigator.userAgent,
          method: 'fallback_user_agent'
        });
        setIsInTeams(true);
      } else {
        setIsInTeams(false);
      }
    })
    .finally(() => {
      setIsLoading(false);
    });
  }, []);

  if (isLoading) {
    return <Loader />;
  }
  //return isInTeams ? element : element;

   return isInTeams ? element : <Navigate to="/access-denied"/>;

};

export default ProtectedRoute;
